export default __webpack_public_path__ + "static/media/signature_karim.7c1278b8.jpeg";